import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader  } from "react-bootstrap";
import { useAuth, useApiPost } from "../../../hooks";
import { SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";

import UserForm from './UserForm';

export default function AddUser({ show, onHide, handleAct, successAlrt=false }) {
    const entityId = localStorage.getItem("entityId");
    const [submitted, setSubmitted] = useState(false);
    const [customerror, setCustomerror] = useState('');
    const { authToken } = useAuth();
    const { postData, loading, error, responseData } = useApiPost('users',authToken);
  
    const handleSubmit = async (formData) => {
      setSubmitted(false);
      setCustomerror('');
      if(formData !== '' && Object.keys(formData).length>0) {
          const entityIdsArr = [];
                entityIdsArr.push(entityId);

          const payloadObj = {
              roleKey: 'employee',
              dob: '1999-01-01',
              entityIds: entityIdsArr,
              ...formData
          };
  
          let payload = JSON.stringify(payloadObj);
          const { result, error: apiError } = await postData(payload);
  
          if(result && result?.data) {
              setSubmitted(true);
              setCustomerror('');
              setTimeout(()=>{
                handleAct();
                setSubmitted(false);
              },300);
          } else {
            setCustomerror(apiError);
          }
      }
      
    };

    const hndlCustomClose = () => {
          setCustomerror('');
          setSubmitted(false);
          onHide();
    }

  return (<Modal role="dialog" className='useradd-form-popup' dialogClassName="right-slide-modal" size='lg' show={show} backdrop centered={false} >
            <div className="modal-content">
              <button type="button" onClick={hndlCustomClose} className="btn-close position-absolute end-0 top-0 m-3"></button>
              <ModalHeader>Add Employee</ModalHeader>
                  <ModalBody>
  
                    <div className="useradd-page">
                      {submitted && <SuccessToolbar message="🎉 Employee have been added successfully." />}
                      {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
                      <UserForm mode="add" onSubmit={handleSubmit} loading={loading} />
                    </div>
          
                </ModalBody>
             </div>
           </Modal>);
}